/*
Usage Notes: 

The following web component can be dropped into any standard Shopify theme (i.e. non-headless), using Liquid to pass product data:

  {% assign skioSellingPlanGroups = product.selling_plan_groups | where: 'app_id', 'SKIO' %}
  {% if skioSellingPlanGroups.size > 0 %}
    <skio-plan-picker 
      product='{{ product | json | escape }}'
      selectedVariant='{{ product.selected_or_first_available_variant | json | escape }}'
      formId='{{ product_form_id }}'
      externalPriceSelector='#price-inner-button .money'
      externalPriceSelectorWithCurrency='[data-product-price-list] .money'
      currency='USD'
      useVariantInputClickEvents='false'
      variantInputSelector=''
      >
    </skio-plan-picker>
    <input type="hidden" aria-hidden="true" name="selling_plan" value="">
    <script src="{{ 'skio-plan-picker-component.js' | asset_url }}" type="module"></script>
    {% render 'skio-details' %}
  {% endif %}

  Note: formId not required if element is inside of a form already

  Example variantChanged event dispatch:
  document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: variant.id } }) );
*/

import {
  LitElement,
  html,
  css,
} from "https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js";

let skioStyles = css`
  .skio-plan-picker {
    display: flex;
    flex-direction: column;
    /* gap: 10px; */
    padding: 0;
    border: 0;
  }
  .skio-onetime-second {
    order: 2;
  }

  .skio-plan-picker-title {
    color: #0d3635;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 16px;
    opacity: .8;
  }
  
  .skio-group-container {
    display: none;
  }
  .skio-group-container--available {
    display: block;
    position: relative;
    border: 1px solid rgba(35,81,69,.7);
    background: #FFF;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    width: 100%;
    transition: all ease-in-out 0.3s;
  }
  .skio-group-container--selected {
    border: 2px solid #235145;
    background: #259B9A;
  }

  .d4-template-featured-product .skio-group-container--selected {
    border: 2px solid #000;
    background: #000;
  }
  
  
  .skio-group-input {
    // position: absolute;
    // width: 0px;
    // height: 0px;
    // opacity: 0;
     position: relative;
    width: 20px;
    height: 20px;
    opacity: 1;
    cursor: pointer;
    min-width: 20px;
    min-height: 20px;
    margin: 0 0 0 19px;
  }
  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
    border-radius: 5px;
     width: 100%;
  }
  
  .skio-group-label {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 19px;
    width: 100%;
  }

  .skio-group-container--selected .skio-group-topline,
  .skio-group-container--selected .skio-price {
    color: #fff;
  }
  
  .skio-group-topline {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    font-weight: 600;
    line-height: 24px;
    text-transform: none;
  }
  
  .skio-radio__container {
    display: none;
  }
  
  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }
  .skio-group-label:hover .skio-radio {
    transform: scale(1);
    opacity: 0.75;
  }
  .skio-group-container--selected .skio-group-label .skio-radio {
    transform: scale(1);
    opacity: 1;
  }
  
  .skio-price {
    font-family: cubano,sans-serif;
    color: #235145;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    margin-left: auto;
  }
    .skio-price span {
       position: absolute;
    right: 10px;
    top: 18px;
  }
  
  .skio-group-content {
    width: auto;
    opacity: 1;
  }
  
  /* Hide frequency if not selected */
  .skio-group-container:not(.skio-group-container--selected) .skio-group-content {
    max-height: 0;
    opacity: 0;
    pointer-events: none;
  }
  
  .skio-group-title {
    min-width: max-content;
  }
  
  .skio-save {
    background: url(https://www.kindlaundry.com/cdn/shop/t/147/assets/save_back.svg) no-repeat center center;
    background-size: 100% 1000%;
    min-width: 118px;
    height: 33px;
    border: 0;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    line-height: 33px;
    display: inline-block;
    padding: 0;
    border-radius: 0;
    vertical-align: middle;
    margin: 0 0 0 4px;
    text-transform: uppercase;
    text-align: center;
  }
  .skio-save-one-time {
    margin-right: 70px !important;
  }
  
  .skio-frequency {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 8px 30px 8px 10px;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-position: right 10px top 50%;
    background-size: 18px;
    background-repeat: no-repeat;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    margin-top: 15px;
    border-radius: 0;
    border: 0;
    background-color: #fff;
  }
  .skio-frequency.skio-frequency--one {
    background-image: none;
    pointer-events: none;
  }
  
  .skio-frequency span {
    text-transform: lowercase;
  }

  .skio-group-container--available:hover  {
      background: rgb(37, 155, 154);
  }
  .skio-group-container--available:hover .skio-price {
     color: rgb(255, 255, 255);
  }
  .skio-group-container--available:hover .skio-group-title {
     color: rgb(255, 255, 255);
  }
  .skio-group-container--available:hover .skio-group-topline {
    color: rgb(255, 255, 255);
  }

  .d4-template-featured-product .skio-group-container--available:hover {
    background: #000;
  }

  .dropdown-inner  {
    position: relative;
    margin-top: 15px;
}
.dropdown-inner  .styledSelect {
    color: rgb(0, 0, 0);
    font-style: normal;
    width: 100%;
    padding: 10px 15px;
    cursor: pointer;
    position: relative;
    background: rgb(255, 255, 255);
    box-sizing: border-box;
    font-size: 14px;
}
.dropdown-inner ul {
    margin: 0;
    color: #000;
    font-size: 14px;
    width: 100%;
    cursor: pointer;
    list-style: none;
    margin-top: 10px;
    position: absolute;
    width: 100%;
    left: 0px;
    background-color: #fff;
    z-index: 1;
    top: 32px;
    padding: 0;
}
.dropdown-inner ul.hide {
    height: 0;
    visibility: hidden;
}
.styledSelect:after {
    content: "";
    width: 12px;
    height: 12px;
    position: absolute;
    top: 16px;
    right: 12px;
    transition: all 0.5s ease;
    background: url(//www.kindlaundry.com/cdn/shop/t/147/assets/arrow-down.svg?v=68173746274564424301696311696) right no-repeat;
}
.styledSelect.active:after {
    transform: rotate(180deg);
}
.dropdown-inner  ul li {
  padding: 10px 15px;
  border-top: 1px solid rgb(35, 81, 69);
}
.dropdown-inner  ul li: hover {
  background: rgba(37, 155, 154, 0.1);
}



  @media(min-width:769px) and (max-width:991px){
    .skio-plan-picker-title { font-size:14px; }
    .skio-group-label { padding: 20px 12px !important; }
    .skio-group-container--selected .skio-group-label { padding: 19px 11px !important; }
    .skio-group-topline{ font-size:14px; }
    .skio-save { min-width: 99px; height: 30px; line-height:30px; }
    .skio-frequency{ font-size:13px !important; }
  }

  @media (min-width: 0px) and (max-width: 768px) {
    .skio-plan-picker-title { font-size:14px; }
    .skio-group-label { padding: 20px 12px; }
    .skio-group-container--selected .skio-group-label { padding: 19px 11px; }
    .skio-group-topline{ font-size:14px;
    
    }
    .skio-save-active.skio-group-topline.one-time{
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }
    .skio-save-active.skio-group-topline.one-time .purchace-option-title{
      grid-column: 1 / -1;
    }
    .skio-save-active.skio-group-topline.one-time .skio-save{
      margin: 0px;
    }
    .skio-save-active.skio-group-topline.one-time  .skio-price{
      margin-top: -23.5px;
    }
    .skio-save { min-width: 99px; height: 30px; line-height:30px; margin: 0px 0px 0px -3px; }
    .skio-save-one-time {margin: 0;}
    .skio-frequency{ font-size:13px; }
    .skio-group-container{ margin-bottom:8px; }

  }

`;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object }, //required
    productHandle: { type: String }, //optional (unless product isn't passed, then required)
    key: { type: String }, //optional, defaults to product.id; identifier for this instance of the Skio plan picker

    formId: { type: String }, //optional; if passed, used to connect input fields to form
    needsFormId: { type: Boolean }, //optional, defaults to false; if true, element needs to be passed a formId, else it searches for a form

    subscriptionFirst: { type: Boolean }, //optional, defaults to false; if true, shows subscription option above onetime
    startSubscription: { type: Boolean }, //optional, defaults to false; if true, auto-selects subscription on page load
    discountFormat: { type: String }, //optional, defaults to percent; can also pass "fixed"

    currency: { type: String }, //optional, defaults to 'USD', but can pass any 3 char identifier
    language: { type: String }, //optional, defaults to 'en-US', but can pass any similarly formatted language identifier
    moneyFormatter: {}, //placeholder for object

    externalPriceSelector: { type: String }, //optional, used to update the external price

    externalPriceSelectorWithCurrency: { type: String }, //optional, used to update the external price

    selectedVariant: { type: Object }, //placeholder for data
    skioSellingPlanGroups: {}, //placeholder for data
    availableSellingPlanGroups: {}, //placeholder for data
    selectedSellingPlanGroup: {}, //placeholder for data
    selectedSellingPlan: {}, //placeholder for data

    defaultFrequency: {}, //placeholder for data

    useVariantInputClickEvents: { type: Boolean }, // optional, allows use of variant input click events to update skio's selectedVariant
    variantInputSelector: {},
  };

  static styles = skioStyles;

  constructor() {
    super();
    this.product = null;
    this.selectedVariant = null;

    this.productHandle = null;

    this.purchaseOption = "onetime";

    this.key = null;
    this.formId = null;
    this.needsFormId = false;

    this.skioSellingPlanGroups = [];
    this.availableSellingPlanGroups = [];

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.startSubscription = false;
    this.subscriptionFirst = false;

    this.skioMainProduct = true;

    this.discountFormat = "percent";

    this.externalPriceSelector = "[skio-external-price]";

    this.externalPriceSelectorWithCurrency =
      "[skio-external-price-with-currency]";

    this.currency = Shopify.currency.active;
    this.language = "en-US";
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: "currency",
      currency: this.currency,
    });

    this.defaultFrequency = null;

    this.useVariantInputClickEvents = null;
    this.variantInputSelector = null;
  }

  connectedCallback() {
    super.connectedCallback();

    if (this.startSubscription == true) {
      this.purchaseOption = "subscription";
    }

    if (!this.product && this.productHandle) {
      this.fetchProduct(this.productHandle);
    }

    if (this.needsFormId && this.formId == null) {
      let forms = document.querySelectorAll('form[action="/cart/add"]');
      if (forms.length > 0) {
        let form;
        forms.forEach((el) => {
          if (el.hasAttribute("skio-key")) {
            if (el.getAttribute("skio-key") == this.key) form = el;
          }
        });
        if (!form) form = forms[0];
        this.formId = form.id;
        this.requestUpdate();
      }
    }
    let skio = this;
    document.addEventListener("variant:change", function (e) {
      //update variant id
      let variantId = e.detail.variant.id;
      let variant = skio.product.variants.find((x) => x.id == variantId);
      if (variant) skio.selectedVariant = variant;
      else skio.log("Unable to find variant with id: ", variantId);
      skio.requestUpdate();
    });

    if (this.useVariantInputClickEvents) {
      document.addEventListener("load", skio.addVariantClickEventListeners);
    }

     // document.dispatchEvent(new CustomEvent('price:update'));
  }
  
  render() {
    if (
      !this.product ||
      !this.selectedVariant ||
      this.skioSellingPlanGroups.length == 0
    )
      return;

    let proType = "One Time";
    let proPrice = "";
    if (document.querySelector("[data-subs-text]") != null) {
      if (this.selectedSellingPlanGroup == null) {
        if (this.selectedVariant.title.includes("Default Title")) {
          proType = "One Time";
        } else {
          proType = "&nbsp/ One Time";
        }
        proPrice = theme.Currency.formatMoney(
          this.selectedVariant.price,
          theme.settings.moneyFormat
        );
      } else if (
        this.selectedSellingPlanGroup != null &&
        this.selectedSellingPlan != undefined
      ) {
        if (this.selectedVariant.title.includes("Default Title")) {
          proType = this.selectedSellingPlan.name;
        } else {
          proType = `&nbsp/ ${this.selectedSellingPlan.name}`;
        }
        proPrice = theme.Currency.formatMoney(
          this.price(this.selectedSellingPlan, false),
          theme.settings.moneyFormat
        );
      }
      document.querySelector("[data-subs-text]").classList.remove("subs-hide");
      document.querySelector("[data-subs-text]").innerHTML = proType;
      document.querySelector("[js-data-product-total-price-2]").innerHTML =
        proPrice;
      document.querySelector("[js-btn-price-desktop]").innerHTML = proPrice;
      document.querySelector("[data-product-price]").innerHTML = this.price(this.selectedSellingPlan);
    }
    this.updateExternalPrice();
    // this.myVariable = ''
    //  this.product.variants.map(variant =>
    //     variant.id == "40562350162003" &&
    //    this.myVariable = `<span class="skio-save">Save <span skio-discount>30%</span></span>`
    //   )

    console.log("this.selectedVariant.id:",this.selectedVariant.id)
    // console.log("this.selectedVariant:", window.compare_price[this.selectedVariant.id])
    let convertionrate = Shopify.currency.rate || 1

    return html`
    <style>
      :host-context(.d4-template-featured-product) .skio-group-container--available {
        border: 2px solid rgb(35, 81, 69);
        background: #FFF;
        color: #000;
      }
      :host-context(.d4-template-featured-product) .skio-group-container--available:hover {
        border: 2px solid #000;
        background: #000;
        color: #FFF;
      }

      :host-context(.d4-template-featured-product) .skio-group-container--available .skio-price {
        color: #000;
      }
      :host-context(.d4-template-featured-product) .skio-group-container--available:hover .skio-price {
        color: #FFF;
      }

      :host-context(.d4-template-featured-product) .skio-group-container--available:hover .skio-save {
        background: url("data:image/svg+xml,%3Csvg width='118' height='33' viewBox='0 0 118 33' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.0438772 1.52439C-0.192226 0.815455 0.725358 0.142801 2.08832 0.0199933C2.28686 0.00324673 2.49077 -0.00233545 2.69468 0.00324673L58.8283 2.09378C58.9463 2.09936 59.0698 2.09936 59.1878 2.09378L115.316 0.00324673C116.695 -0.0469929 117.897 0.491688 117.994 1.21179C118.01 1.31785 117.994 1.42112 117.961 1.52439L113.084 16.2781C113.035 16.4232 113.035 16.574 113.084 16.7191L117.956 31.4756C118.192 32.1845 117.275 32.86 115.912 32.98C115.713 32.9968 115.509 33.0023 115.311 32.9968L59.1771 30.9062C59.059 30.9006 58.9356 30.9006 58.8176 30.9062L2.68394 32.9968C1.30488 33.047 0.102903 32.5083 0.00631531 31.791C-0.00978266 31.6849 0.00631531 31.5817 0.0385112 31.4756L4.91619 16.7219C4.96449 16.5768 4.96449 16.426 4.91619 16.2809L0.0438772 1.52439Z' fill='%23FFF'/%3E%3C/svg%3E") no-repeat center center;
        color: #000;
      }
      
      :host-context(.d4-template-featured-product) .skio-group-container--available .skio-save {
        background: url("data:image/svg+xml,%3Csvg width='118' height='33' viewBox='0 0 118 33' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.0438772 1.52439C-0.192226 0.815455 0.725358 0.142801 2.08832 0.0199933C2.28686 0.00324673 2.49077 -0.00233545 2.69468 0.00324673L58.8283 2.09378C58.9463 2.09936 59.0698 2.09936 59.1878 2.09378L115.316 0.00324673C116.695 -0.0469929 117.897 0.491688 117.994 1.21179C118.01 1.31785 117.994 1.42112 117.961 1.52439L113.084 16.2781C113.035 16.4232 113.035 16.574 113.084 16.7191L117.956 31.4756C118.192 32.1845 117.275 32.86 115.912 32.98C115.713 32.9968 115.509 33.0023 115.311 32.9968L59.1771 30.9062C59.059 30.9006 58.9356 30.9006 58.8176 30.9062L2.68394 32.9968C1.30488 33.047 0.102903 32.5083 0.00631531 31.791C-0.00978266 31.6849 0.00631531 31.5817 0.0385112 31.4756L4.91619 16.7219C4.96449 16.5768 4.96449 16.426 4.91619 16.2809L0.0438772 1.52439Z' fill='%23000'/%3E%3C/svg%3E") no-repeat center center;
        color: #FFF;
      }
      
      :host-context(.d4-template-featured-product) .skio-group-container--selected {
        border: 2px solid #000;
        background: #000;
        color: #FFF;
      }

      :host-context(.d4-template-featured-product) .skio-group-container--selected .skio-price {
        color: #FFF;
      }

      :host-context(.d4-template-featured-product) .skio-group-container--selected .skio-save {
        background: url("data:image/svg+xml,%3Csvg width='118' height='33' viewBox='0 0 118 33' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.0438772 1.52439C-0.192226 0.815455 0.725358 0.142801 2.08832 0.0199933C2.28686 0.00324673 2.49077 -0.00233545 2.69468 0.00324673L58.8283 2.09378C58.9463 2.09936 59.0698 2.09936 59.1878 2.09378L115.316 0.00324673C116.695 -0.0469929 117.897 0.491688 117.994 1.21179C118.01 1.31785 117.994 1.42112 117.961 1.52439L113.084 16.2781C113.035 16.4232 113.035 16.574 113.084 16.7191L117.956 31.4756C118.192 32.1845 117.275 32.86 115.912 32.98C115.713 32.9968 115.509 33.0023 115.311 32.9968L59.1771 30.9062C59.059 30.9006 58.9356 30.9006 58.8176 30.9062L2.68394 32.9968C1.30488 33.047 0.102903 32.5083 0.00631531 31.791C-0.00978266 31.6849 0.00631531 31.5817 0.0385112 31.4756L4.91619 16.7219C4.96449 16.5768 4.96449 16.426 4.91619 16.2809L0.0438772 1.52439Z' fill='%23FFF'/%3E%3C/svg%3E") no-repeat center center;
        color: #000;
      }


      .skio-plan-picker:not([d4-product="4490719199315"]) .skio-group-container input + label .d4-laundry-show {
        display: none;
      }


      .skio-plan-picker[d4-product="4490719199315"] .skio-group-container:not(.skio-onetime-second):has(input:not(:checked)) {
        align-items: start;
      }
      
      .skio-plan-picker[d4-product="4490719199315"] .skio-group-container:not(.skio-onetime-second) input:not(:checked) {
        margin: 24px 0 19px 19px;
      }
      
      .skio-plan-picker[d4-product="4490719199315"] .skio-group-container input + label .d4-laundry-show {
        display: block;
        padding: 0;
        margin-bottom: 0;
        font-size: 14px;
      }

      .skio-plan-picker[d4-product="4490719199315"] .skio-group-container input + label .d4-laundry-show span {
        font-weight: bold;
      }
      
      .skio-plan-picker[d4-product="4490719199315"] .skio-group-container input:checked + label .d4-laundry-show,
      .skio-plan-picker[d4-product="4490719199315"] .skio-group-container input:hover + label .d4-laundry-show {
        color: #FFF;
      }
      
      .skio-plan-picker[d4-product="4490719199315"] .skio-group-container input:checked + label .d4-laundry-show li::marker {
        margin-right: 7px;
      }

      @media screen and (max-width: 768px) {
        .skio-plan-picker[d4-product="4490719199315"] .skio-group-container input + label .d4-laundry-show {
          font-size: 12px;
        }
      }
    </style>
      <fieldset class="skio-plan-picker" skio-plan-picker="${this.key}" d4-product="${this.product.id}">
      <p class="skio-plan-picker-title">Choose an Option</p>
        <input ${
          this.formId !== null ? html`form="${this.formId}"` : ""
        } name="selling_plan" type="hidden" value="${
      this.selectedSellingPlan !== null ? this.selectedSellingPlan?.id : ""
    }" />
        <input ${
          this.formId !== null ? html`form="${this.formId}"` : ""
        } name="properties[Discount]" type="hidden" value="${
      this.selectedSellingPlan !== null
        ? this.discount(this.selectedSellingPlan).percent
        : ""
    }" 
          ?disabled="${this.selectedSellingPlan == null ? true : false}" />

          <input id="subscription-true" type="hidden" name="properties[_subscription]" value="${ this.selectedSellingPlan !== null ? 'true' : ''}">
        
        <div class="skio-group-container ${
          this.product.requires_selling_plan == false
            ? "skio-group-container--available"
            : ""
        } ${
      this.selectedSellingPlanGroup == null
        ? "skio-group-container--selected"
        : ""
    } ${
      this.subscriptionFirst ? "skio-onetime-second" : ""
    }" skio-group-container 
          @click=${() => this.selectSellingPlanGroup(null)} >
        
          <input id="skio-one-time-${
            this.key
          }" class="skio-group-input" name="skio-group-${
      this.key
    }" type="radio" value="" 
            skio-one-time ?checked=${
              this.startSubscription == false &&
              this.product.requires_selling_plan == false
                ? true
                : false
            }>
          <label class="skio-group-label" for="skio-one-time-${this.key}">
            <div class="skio-group-topline one-time ${this.selectedVariant.id == "40562350162003"?'skio-save-active':''}">
            <div class="purchace-option-title">
              <div class="skio-radio__container">
               
              </div>
              One Time Purchase 
              </div>



                  
               ${
                 this.selectedVariant.id == "40562350162003"
                   ? html``
                   : ""
               }

 
               ${
                this.selectedVariant.compare_at_price && this.product.handle === 'detergent-sheets' 
                  ? html`
                <span class="skio-save skio-save-one-time">Save <span skio-discount>${
                  this.selectedVariant.compare_at_price ? Math.round(((this.selectedVariant.compare_at_price - this.selectedVariant.price) * 100.0) / this.selectedVariant.compare_at_price) : ''
                }%</span></span>
              `
                  : html``
              }
                
              <div class="skio-price ssss" style="display: flex; flex-direction: column;">
                ${this.selectedVariant && window.compare_price && window.compare_price.hasOwnProperty(this.selectedVariant.id)
                      ? parseFloat(window.compare_price[this.selectedVariant.id]) < this.selectedVariant.price / 100
                          ? html`<span skio-onetime-price>${this.moneyFormatter.format(
                                window.compare_price[this.selectedVariant.id] * convertionrate
                            )}</span><del class="skio_compare-price" style="opacity: 0.75;">${this.moneyFormatter.format(this.selectedVariant.price / 100)}</del>`
                          : html`<span skio-onetime-price>${this.moneyFormatter.format(this.selectedVariant.price / 100)}</span>`
                      : ""
                  }

              </div>
            </div>
          </label>
        </div>
        ${
          this.availableSellingPlanGroups
            ? this.availableSellingPlanGroups.map(
                (group, index) =>
                  html`
            <div class="skio-group-container skio-group-container--available ${
              this.selectedSellingPlanGroup == group
                ? "skio-group-container--selected"
                : ""
            }" skio-group-container
              @click=${() => this.selectSellingPlanGroup(group)}>
              <input id="skio-selling-plan-group-${index}-${
                    this.key
                  }" class="skio-group-input" name="skio-group-${this.key}"
                type="radio" value="${group.id}" skio-selling-plan-group="${
                    group.id
                  }" ?checked=${
                    this.selectedSellingPlanGroup == group ? true : false
                  } >
              <label class="skio-group-label" for="skio-selling-plan-group-${index}-${
                    this.key
                  }">
                <div class="skio-group-topline">
                  <div class="skio-radio__container">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
                      <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
                    </svg>
                  </div>
                  <div class="skio-group-title">
                    Subscribe
                    ${
                      this.discount(group.selected_selling_plan).percent !==
                      "0%"
                        ? html`
                      <span class="skio-save">Save <span skio-discount>${
                        this.discountFormat == "percent"
                          ? this.discount(group.selected_selling_plan).percent
                          : this.discount(group.selected_selling_plan).amount
                      }</span></span>
                    `
                        : html``
                    }
                  </div>
                  <div class="skio-price">
                    <span skio-subscription-price>${this.price(
                      group.selected_selling_plan
                    )}</span>
                  </div>
                </div>
                <ul class="d4-laundry-show"><li>Pause, Skip or Cancel Anytime!</li></ul>
                <div class="skio-group-content">


                 <div skio-selling-plans="${group.id}" class="dropdown-inner ${
                    group.selling_plans.length == 1 ? "skio-frequency--one" : ""
                  }">
                     <div data-dropdown class="styledSelect" @click=${(e) =>
                       this.selectSellingPlan(
                         e.target,
                         group
                       )}>Delivery ${group.selected_selling_plan.name.toLowerCase()}</div>
                     <ul data-values class="options hide">
                        ${
                          group
                            ? group.selling_plans.map(
                                (selling_plan) =>
                                  html`
                           <li @click=${(e) =>
                             this.selectSellingPlan(
                               e.target,
                               group
                             )} data-value="${selling_plan.id}"> ${
                                    group.name == "Subscription"
                                      ? `Delivery ${selling_plan.name.toLowerCase()}`
                                      : `${selling_plan.name}`
                                  }</li>
                         `
                              )
                            : ""
                        }
                     </ul>
                </div>

                
               
                  
                </div>
              </label>
            </div>
          `
              )
            : ""
        }
      </fieldset>`;
  }

  updated = (changed) => {
    if(changed.has('product') && this.product) {
      //update key
      this.key = this.key ? this.key : this.product.id;

      //update skioSellingPlanGroups
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group => selling_plan_group.app_id === 'SKIO'
      )

      this.skioSellingPlanGroups.forEach((group) => {
        group.selling_plans.sort(function(a,b){
          if (parseInt(a.name.replace(/\D/g, "")) < parseInt(b.name.replace(/\D/g, ""))) return -1;
          if (parseInt(a.name.replace(/\D/g, "")) > parseInt(b.name.replace(/\D/g, ""))) return 1;
          if (parseInt(a.name.replace(/\D/g, "")) == parseInt(b.name.replace(/\D/g, ""))) return 0;
        })
      });

    }

    if(changed.has('selectedVariant') && this.selectedVariant) {
      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      let skioSellingPlanGroups = JSON.parse(JSON.stringify(this.skioSellingPlanGroups));
      this.availableSellingPlanGroups = skioSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(
            selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
          )
        )
      )

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups?.length > 0) {
        //update each group with a default selected_selling_plan

        this.availableSellingPlanGroups.forEach((group) => {
          group.selling_plans = group.selling_plans.filter(x => this.selectedVariant.selling_plan_allocations.find(y => y.selling_plan_id == x.id) );
        })

        this.availableSellingPlanGroups.forEach((group => {
          if (this.defaultFrequency) {
            let selling_plan = group.selling_plans.find(x => x.name.toLowerCase().includes(this.defaultFrequency.toLowerCase()));
            if (selling_plan) group.selected_selling_plan = selling_plan;
            else group.selected_selling_plan = group.selling_plans[0];
          } else {
            group.selected_selling_plan = group.selling_plans[0];
          }
       }));

        if (this.startSubscription == true || this.product.requires_selling_plan == true || this.purchaseOption == 'subscription') {
          //find a matching selling plan, or choose first available

          if (this.selectedSellingPlan == null || this.selectedSellingPlan == undefined) {
            this.selectSellingPlanGroup(this.availableSellingPlanGroups[0]);
          }

          let sellingPlanName = this.selectedSellingPlan?.name;

          let sellingPlanGroup = this.availableSellingPlanGroups.find(x => x.selling_plans.find(y => y.name == sellingPlanName));
          let sellingPlan = sellingPlanGroup?.selling_plans.find(y => y.name == sellingPlanName);
          if (sellingPlanName == sellingPlan.name) {
            this.selectedSellingPlanGroup = sellingPlanGroup;
            this.selectedSellingPlan = sellingPlan;
          } else {
          this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];
          this.selectedSellingPlan = this.availableSellingPlanGroups[0].selling_plans[0];
          }

        } else {
          this.selectedSellingPlan, this.selectedSellingPlanGroup = null
        }
      } else {
        this.selectedSellingPlan, this.selectedSellingPlanGroup = null
      }

      //update the form that was passed, if any
      this.updateForm();

    }

    if(changed.has('selectedSellingPlan')) {
      //update price of price elements if applicable
      document.querySelectorAll(`[skio-price][skio-key="${ this.key }"]`).forEach((el) => {
        el.innerHTML = this.price(this.selectedSellingPlan);
      });

      //update display of external content elements
      document.querySelectorAll(`[skio-onetime-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan !== null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      document.querySelectorAll(`[skio-subscription-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan == null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true, 
        composed: true, 
        detail: {
          sellingPlan: this.selectedSellingPlan,
          key: this.key
        }
      });

      this.dispatchEvent(event);

      //update the form that was passed, if any
      this.updateForm();
      this.updateExternalPrice();

      //update external selling_plan input value
      let sellingPlanInput = document.querySelector('input[name="selling_plan"]')
      this.selectedSellingPlan != null ? sellingPlanInput.value = this.selectedSellingPlan.id : sellingPlanInput.value = ''

    }

    if(changed.has('formId')) {
      //update the form that was passed, if any
      this.updateForm();
    }

  }

  log = (...args) => {
    args.unshift("%c[skio]", "color: #8770f2;");
    console.log.apply(console, args);
  };

  error = (...args) => {
    args.unshift("%c [skio]", "color: #ff0000");
    console.error.apply(console, args);
  };

  updateExternalPrice() {
    document.querySelectorAll(this.externalPriceSelector).forEach((el) => {
      el.innerHTML = this.price(this.selectedSellingPlan);
    });
    document
      .querySelectorAll(this.externalPriceSelectorWithCurrency)
      .forEach((el) => {
        el.innerHTML = this.price(this.selectedSellingPlan);
      });
  }

  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;
    if (group) this.purchaseOption = "subscription";
    else this.purchaseOption = "onetime";

    //update the form that was passed, if any
    this.updateForm();
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(element, group) {
    if (element.hasAttribute("data-dropdown")) {
      element.classList.toggle("active");
      element.nextElementSibling.classList.toggle("hide");
      return false;
    } else {
      element.parentElement.classList.toggle("hide");
      element.parentElement.previousElementSibling.classList.toggle("active");
    }

    // if(document.querySelector('[data-dropdown]') != null) {
    //  document.querySelector('[data-values]').classList.toggle('hide-dropdown');
    //  document.querySelector('[data-dropdown]').classList.remove('active');
    // }

    let selling_plan = group.selling_plans.find(
      (x) => x.id == element.getAttribute("data-value")
    );

    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
    } else
      this.log(
        "Error: couldn't find selling plan with id " +
          element.value +
          " for variant " +
          this.selectedVariant.id +
          " from product " +
          this.product.id +
          " : " +
          this.product.handle
      );
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0);
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {
    if (!selling_plan) return { percent: "0%", amount: 0 };

    const price_adjustment = selling_plan.price_adjustments[0];
    const discount = { percent: "0%", amount: 0 };
    const price = this.selectedVariant.price;
    const compare_price = this.selectedVariant.compare_at_price;
    const extra_percentage = compare_price ? Math.round(((compare_price - price) * 100.0) / compare_price) : null
    console.log(this.product.handle)

    switch (price_adjustment.value_type) {
      case "percentage":
        if (this.product.handle === 'detergent-sheets') {
          if (this.selectedVariant.title.includes('180 Loads')) {
            discount.percent = `24%`;
          } else if (this.selectedVariant.title.includes('360 Loads')) {
            discount.percent = `28%`;
          } else {
            discount.percent = `${price_adjustment.value + (extra_percentage ? extra_percentage : 0)}%`;
          }
        } else {
          discount.percent = `${price_adjustment.value}%`;
        }
        discount.amount = Math.round((price * price_adjustment.value) / 100.0);
        break;
      case "fixed_amount":
        discount.percent = `${Math.round(
          ((price_adjustment.value * 1.0) / price) * 100.0
        )}%`;
        discount.amount = price_adjustment.value;
        break;
      case "price":
        discount.percent = `${Math.round(
          (((price - price_adjustment.value) * 1.0) / price) * 100.0
        )}%`;
        discount.amount = price - price_adjustment.value;
        break;
    }

    return discount;
  }

  // Calculates the variant's price for the given selling plan, returns a formatted money value (if desired)
  price(selling_plan, formatted = true) {
    return formatted
      ? this.money(
          this.selectedVariant.price - this.discount(selling_plan).amount
        )
      : this.selectedVariant.price - this.discount(selling_plan).amount;
  }

  // If a formId was passed, appends the necessary <input> elements to the form
  updateForm() {
    if (this.formId) {
      let form = document.querySelector(`#${this.formId}`);

      if (form) {
        let selling_plan_input = form.querySelector('[name="selling_plan"]');
        if (selling_plan_input) {
          selling_plan_input.value =
            this.selectedSellingPlan?.id !== undefined
              ? this.selectedSellingPlan?.id
              : null;
          selling_plan_input.disabled =
            this.selectedSellingPlan?.id !== undefined ? false : true;
        } else {
          selling_plan_input = document.createElement("input");
          selling_plan_input.type = "hidden";
          selling_plan_input.name = "selling_plan";
          selling_plan_input.value =
            this.selectedSellingPlan?.id !== undefined
              ? this.selectedSellingPlan?.id
              : null;
          selling_plan_input.disabled =
            this.selectedSellingPlan?.id !== undefined ? false : true;
          form.append(selling_plan_input);
        }

        let discount_input = form.querySelector(
          '[name="properties[Discount]"]'
        );
        if (discount_input) {
          discount_input.value =
            this.selectedSellingPlan?.id !== undefined
              ? this.discount(this.selectedSellingPlan).percent
              : null;
          discount_input.disabled =
            this.selectedSellingPlan?.id !== undefined ? false : true;
        } else {
          discount_input = document.createElement("input");
          discount_input.type = "hidden";
          discount_input.name = "properties[Discount]";
          discount_input.value =
            this.selectedSellingPlan?.id !== undefined
              ? this.discount(this.selectedSellingPlan).percent
              : null;
          discount_input.disabled =
            this.selectedSellingPlan?.id !== undefined ? false : true;
          form.append(discount_input);
        }

        let tracking_input = form.querySelector(
          '[name="properties[_subscription]"]'
        );
        if (tracking_input) {
          tracking_input.value = this.selectedSellingPlan?.id !== undefined ? 'true' : '';
          tracking_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
        } else {
          tracking_input = document.createElement("input");
          tracking_input.type = "hidden";
          tracking_input.name = "properties[_subscription]";
          tracking_input.value = this.selectedSellingPlan?.id !== undefined ? 'true' : '';
          tracking_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
          form.append(tracking_input);
        }
      } else {
        console.log(
          `Skio error: form ID is ${this.formId}, but no form with that ID was found.`
        );
      }
    }
  }

  addVariantClickEventListeners() {
    let variantInputs = document.querySelectorAll(this.variantInputSelector);
    let skio = this;
    for (let el of variantInputs) {
      el.addEventListener("click", function (e) {
        // may need to replace with ID / e.target depending on client setup
        // may need to use different attribute depending on ^^
        let variantTitle = e.currentTarget.value;
        skio.selectedVariant = skio.product.variants.find(
          (variant) => variant.title == variantTitle
        );
      });
    }
  }

  // Optional functions keep if necessary

  /**
   *
   *
   */

  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && {
          selling_plan: this.selectedSellingPlan?.id,
        }),
      },
    ];

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items }),
    })
      .then((response) => response.json())
      .then((response) => {
        this.log("SKIO added item to cart: ", response);
        //dispatch CustomEvent to tell document that an item was added to cart
        const event = new CustomEvent(`skio::added-to-cart`, {
          bubbles: true,
          composed: true,
          detail: {
            response,
            key: this.key,
          },
        });

        this.dispatchEvent(event);
      })
      .catch((error) => {
        this.error(`SKIO ${this.key} error adding item to cart: `, error);
      });
  }

  fetchProduct = (handle) => {
    return fetch(`/products/${handle}.js`)
      .then((response) => response.json())
      .then((product) => {
        this.product = product;
        this.selectedVariant = product.variants[0];

        return product;
      });
  };
}

customElements.define("skio-plan-picker", SkioPlanPickerComponent);
